
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1AU2X", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    /**
     * Boolean with the result of the check if package
     * is running on the browser or in a NodeJS environment
     *
     * @returns boolean
     *
     */ var isNodeJSEnv = Object.prototype.toString.call(typeof $1P2f3 !== 'undefined' ? $1P2f3 : 0) === '[object process]';
    /**
     * Boolean with the result of the check if User Timing API
     * is supported for the current browser/NodeJS version
     *
     * @returns boolean
     *
     */ var isUserTimingAPISupported = typeof performance !== 'undefined' && typeof performance.now !== 'undefined' && typeof performance.mark === 'function' && typeof performance.measure === 'function' && (typeof performance.clearMarks === 'function' || typeof performance.clearMeasures === 'function');
    /**
     * Boolean with the result of the check if PerformanceObservable
     * is supported for the current browser/NodeJS version
     *
     * @returns boolean
     *
     */ var isPerformanceObservableSupported = typeof PerformanceObserver !== 'undefined' && // eslint-disable-next-line compat/compat
    typeof PerformanceObserver.prototype !== 'undefined' && // eslint-disable-next-line compat/compat
    typeof PerformanceObserver.prototype.constructor === 'function';
    // Map() is not used in order to decrease the bundle
    var marksMap = {};
    var marksObserver = {};
    /**
     * Get the current time based on User Timing API or Date
     *
     * @returns number
     *
     */ var getTimeNow = function() {
        return isUserTimingAPISupported ? performance.now() : Date.now();
    };
    /**
     * Clear marks and measure of performance event
     *
     * @param markName - Performance marker to be checked
     *
     * @returns void
     *
     */ var clear = function(markName) {
        marksMap[markName] = undefined;
        // Removes PerformanceObserver references from memory
        if (!!marksObserver[markName]) marksObserver[markName] = undefined;
        if (!isUserTimingAPISupported) return;
        // Some versions of NodeJS doesn't support this method
        if (!isNodeJSEnv) performance.clearMeasures(markName);
        performance.clearMarks(markName);
    };
    /**
     * Start performance measure of event
     *
     * @param markName - Performance marker to be started
     *
     * @returns number
     *
     */ var start = function(markName) {
        if (isUserTimingAPISupported) {
            if (isNodeJSEnv && isPerformanceObservableSupported) {
                // eslint-disable-next-line compat/compat
                var obs_1 = new PerformanceObserver(function(list) {
                    marksObserver[markName] = list.getEntries().find(function(f) {
                        return f.name === markName;
                    });
                    obs_1.disconnect();
                });
                obs_1.observe({
                    entryTypes: [
                        'measure'
                    ]
                });
            }
            performance.mark(markName);
        }
        marksMap[markName] = getTimeNow();
    };
    /**
     * Finishes performance measure of event and
     * clear marks and measure if applicable
     *
     * @param markName - Performance marker to be checked
     * @param markNameToCompare - Optional mark to compare to
     *
     * @returns PerfMarksPerformanceEntry
     *
     */ var end = function(markName, markNameToCompare) {
        try {
            var startTime = marksMap[markName];
            if (!isUserTimingAPISupported) return startTime ? {
                duration: getTimeNow() - startTime,
                startTime: startTime,
                entryType: 'measure',
                name: markName
            } : {};
            // If there's no User Timing mark to be compared with,
            // the package will create one to be used for better comparison
            if (!markNameToCompare) performance.mark(markName + "-end");
            performance.measure(markName, markName, markNameToCompare || markName + "-end");
            if (isNodeJSEnv) {
                if (!!marksObserver[markName]) return marksObserver[markName];
                return startTime ? {
                    duration: getTimeNow() - startTime,
                    startTime: startTime,
                    entryType: 'measure',
                    name: markName
                } : {};
            }
            var entry = performance.getEntriesByName(markName).pop();
            return entry || {};
        } catch (e) {
            // If previous mark was missing for some reason, this will throw.
            // This could only happen if something in event loop crashed
            // in an unexpected place earlier.
            // Don't pile on with more errors.
            return {};
        } finally{
            // Clear marks immediately to avoid growing buffer.
            clear(markName);
            // Clear marks used for comparison in case of it's value was passed
            // If the mark to compare is not passed, it should remove the one we create with `-end` suffix
            clear(markNameToCompare || markName + "-end");
        }
    };
    /**
     * Clear all marks and measures of performance event
     *
     * @returns void
     *
     */ var clearAll = function() {
        marksMap = {};
        marksObserver = {};
        if (!isUserTimingAPISupported) return;
        // Some versions of NodeJS doesn't support this method
        if (!isNodeJSEnv) performance.clearMeasures();
        performance.clearMarks();
    };
    /**
     * Gets the result for all marks that matches with the given mark name
     *
     * @param markName - Performance marker to be checked
     *
     * @returns PerfMarksPerformanceNavigationTiming[]
     *
     */ var getEntriesByType = function(entryName) {
        // NodeJS doesn't have support for getEntriesByType
        if (!isUserTimingAPISupported || isNodeJSEnv) return [];
        return performance.getEntriesByType(entryName) || [];
    };
    /**
     * Gets the marks for `navigation` loaded mark
     *
     * @returns PerfMarksPerformanceNavigationTiming[]
     *
     */ var getNavigationMarker = function() {
        return getEntriesByType('navigation').pop() || {};
    };
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    /**
     * profiler using User Timing Api method.
     * It will return a `PerfMarksPerformanceEntry` or
     * an PerfMarksPerformanceEntry inside `mark` key + the content for the callback method
     * If the given callback returns something
     *
     * usage:
     *
     * perfMarksProfile(
     *   () => { /** method content *\/}
     *   'name of the mark for this method',
     *   );
     *
     * @param {(() => any | Promise<any>)} callback
     * @param {string} name
     * @returns {Promise<PerfMarksPerformanceEntry>}
     */ var profiler = function(callback, name) {
        return __awaiter(void 0, void 0, void 0, function() {
            var data, mark, error_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Starting the marks
                        start(name);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            callback()
                        ];
                    case 2:
                        data = _a.sent();
                        mark = end(name);
                        // Passing data as an object
                        return [
                            2 /*return*/ ,
                            !!data ? Object.assign({}, {
                                data: data,
                                mark: mark
                            }) : {
                                mark: mark
                            }
                        ];
                    case 3:
                        error_1 = _a.sent();
                        end(name);
                        throw error_1;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    exports1.clear = clear;
    exports1.clearAll = clearAll;
    exports1.end = end;
    exports1.getEntriesByType = getEntriesByType;
    exports1.getNavigationMarker = getNavigationMarker;
    exports1.isNodeJSEnv = isNodeJSEnv;
    exports1.isPerformanceObservableSupported = isPerformanceObservableSupported;
    exports1.isUserTimingAPISupported = isUserTimingAPISupported;
    exports1.profiler = profiler;
    exports1.start = start;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("gVALF", function(module, exports) {

var $6Ddc1 = parcelRequire("6Ddc1");


var $i3Vgm = parcelRequire("i3Vgm");

const $e0d1c6465ac045b2$export$c8b741e18397852a = ()=>{
    return (0, $6Ddc1.getValueFromSessionStorage)((0, $i3Vgm.MEDIA_API_ENVIRONMENT));
};
module.exports["getMediaEnvironment"] = $e0d1c6465ac045b2$export$c8b741e18397852a;

});

parcelRegister("6Ddc1", function(module, exports) {
const $f40b2953c0c0606d$export$f20304eca88db25f = (key)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
module.exports["getValueFromSessionStorage"] = $f40b2953c0c0606d$export$f20304eca88db25f;

});

parcelRegister("cFc8s", function(module, exports) {

var $6Ddc1 = parcelRequire("6Ddc1");


var $i3Vgm = parcelRequire("i3Vgm");

const $30fc97e3bdf84e4a$export$20f9315304dd6726 = ()=>{
    return (0, $6Ddc1.getValueFromSessionStorage)((0, $i3Vgm.MEDIA_API_REGION));
};
module.exports["getMediaRegion"] = $30fc97e3bdf84e4a$export$20f9315304dd6726;

});

parcelRegister("fZy9o", function(module, exports) {
const $9748c61b9134e546$var$packageName = "platform-pkg";
const $9748c61b9134e546$var$packageVersion = "0.0.0-use.local";
function $9748c61b9134e546$export$12e3140bad86f969(componentName) {
    return {
        packageName: $9748c61b9134e546$var$packageName,
        packageVersion: $9748c61b9134e546$var$packageVersion,
        componentName: componentName,
        component: componentName
    };
}
module.exports["getPackageAttributes"] = $9748c61b9134e546$export$12e3140bad86f969;

});

parcelRegister("588Xi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $a2foB = parcelRequire("a2foB");


var $lqtHz = parcelRequire("lqtHz");


var $5avUB = parcelRequire("5avUB");




const $70a8af3c8e842b4e$export$889413494ace092f = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "fabric.media.errorFlagTitle",
        defaultMessage: "Your file failed to upload"
    },
    uploadRejectionDescription: {
        id: "fabric.media.uploadRejectionFlagDescription",
        defaultMessage: "{fileName} is too big to upload. Files must be less than {limit}."
    },
    fileEmptyDescription: {
        id: "fabric.media.fileEmptyFlagDescription",
        defaultMessage: "The file you selected was empty. Please select another file and try again."
    }
});


const $9ec14c3b7413f5ad$var$defaultOptions = {
    style: 'unit',
    unitDisplay: 'short',
    minimumFractionDigits: 2
};
const $9ec14c3b7413f5ad$var$fileSizeFormatters = {
    kilobyte: new Intl.NumberFormat('en', {
        ...$9ec14c3b7413f5ad$var$defaultOptions,
        unit: 'kilobyte'
    }),
    megabyte: new Intl.NumberFormat('en', {
        ...$9ec14c3b7413f5ad$var$defaultOptions,
        unit: 'megabyte'
    }),
    gigabyte: new Intl.NumberFormat('en', {
        ...$9ec14c3b7413f5ad$var$defaultOptions,
        unit: 'gigabyte'
    })
};
const $9ec14c3b7413f5ad$var$formatFileSize = (size)=>{
    let formattedSize;
    if (size < 1000000) {
        formattedSize = size / 1000;
        return $9ec14c3b7413f5ad$var$fileSizeFormatters.kilobyte.format(formattedSize);
    } else if (size >= 1000000 && size < 1000000000) {
        formattedSize = size / 1000000;
        return $9ec14c3b7413f5ad$var$fileSizeFormatters.megabyte.format(formattedSize);
    } else {
        formattedSize = size / 1000000000;
        return $9ec14c3b7413f5ad$var$fileSizeFormatters.gigabyte.format(formattedSize);
    }
};
const $9ec14c3b7413f5ad$var$FlagGroupContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { flagData: flagData, onFlagDismissed: onFlagDismissed } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== flagData || $[1] !== intl) {
        let t2;
        if ($[3] !== intl) {
            t2 = (data, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2foB.default), {
                    id: i,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        label: "Fail",
                        spacing: "spacious"
                    }),
                    key: i,
                    title: intl.formatMessage((0, $70a8af3c8e842b4e$export$889413494ace092f).errorTitle),
                    description: data.reason === "fileEmpty" ? intl.formatMessage((0, $70a8af3c8e842b4e$export$889413494ace092f).fileEmptyDescription, {
                        fileName: data.fileName
                    }) : intl.formatMessage((0, $70a8af3c8e842b4e$export$889413494ace092f).uploadRejectionDescription, {
                        fileName: data.fileName,
                        limit: $9ec14c3b7413f5ad$var$formatFileSize(data.limit)
                    })
                });
            $[3] = intl;
            $[4] = t2;
        } else t2 = $[4];
        t1 = flagData.map(t2);
        $[0] = flagData;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== onFlagDismissed || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
            onDismissed: onFlagDismissed
        }, t1);
        $[5] = onFlagDismissed;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ flagData: flagData, onFlagDismissed: onFlagDismissed })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
        onDismissed: onFlagDismissed
    }, flagData.map((data, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2foB.default), {
            id: i,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                color: "var(--ds-icon-danger, #C9372C)",
                label: "Fail",
                spacing: "spacious"
            }),
            key: i,
            title: intl.formatMessage((0, $70a8af3c8e842b4e$export$889413494ace092f).errorTitle),
            description: data.reason === 'fileEmpty' ? intl.formatMessage((0, $70a8af3c8e842b4e$export$889413494ace092f).fileEmptyDescription, {
                fileName: data.fileName
            }) : intl.formatMessage((0, $70a8af3c8e842b4e$export$889413494ace092f).uploadRejectionDescription, {
                fileName: data.fileName,
                limit: $9ec14c3b7413f5ad$var$formatFileSize(data.limit)
            })
        })));
};
const $9ec14c3b7413f5ad$var$ErrorFlagGroup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { flagData: flagData, onFlagDismissed: onFlagDismissed, intl: intl } = t0;
    let t1;
    if ($[0] !== flagData || $[1] !== intl || $[2] !== onFlagDismissed) {
        t1 = intl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9ec14c3b7413f5ad$var$FlagGroupContent, {
            flagData: flagData,
            onFlagDismissed: onFlagDismissed
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: "en"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9ec14c3b7413f5ad$var$FlagGroupContent, {
            flagData: flagData,
            onFlagDismissed: onFlagDismissed
        }));
        $[0] = flagData;
        $[1] = intl;
        $[2] = onFlagDismissed;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ flagData: flagData, onFlagDismissed: onFlagDismissed, intl: intl })=>{
    return intl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9ec14c3b7413f5ad$var$FlagGroupContent, {
        flagData: flagData,
        onFlagDismissed: onFlagDismissed
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9ec14c3b7413f5ad$var$FlagGroupContent, {
        flagData: flagData,
        onFlagDismissed: onFlagDismissed
    }));
};
const $9ec14c3b7413f5ad$var$_default_1 = (0, $kSwu1.injectIntl)($9ec14c3b7413f5ad$var$ErrorFlagGroup, {
    enforceContext: false
});
var $9ec14c3b7413f5ad$export$2e2bcd8739ae039 = $9ec14c3b7413f5ad$var$_default_1;
module.exports["default"] = $9ec14c3b7413f5ad$export$2e2bcd8739ae039;

});

parcelRegister("brE4f", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1AU2X = parcelRequire("1AU2X");

function $9ff424163e805d7a$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}


function $e5ee1fb593dbb4c1$export$c15d72765ee2baa4(err) {
    return (0, $9ff424163e805d7a$export$2491e0bbdb59256e)(err) ? err.attributes.reason : 'unknown';
}


var $1wzQC = parcelRequire("1wzQC");


var $8lZ3h = parcelRequire("8lZ3h");


var $7XeMy = parcelRequire("7XeMy");


var $03RpJ = parcelRequire("03RpJ");


var $dBBnL = parcelRequire("dBBnL");


var $fkYei = parcelRequire("fkYei");


var $hfrng = parcelRequire("hfrng");


var $eZgLI = parcelRequire("eZgLI");


var $f4X7g = parcelRequire("f4X7g");


var $8396x = parcelRequire("8396x");


var $9OT81 = parcelRequire("9OT81");


var $nfEzS = parcelRequire("nfEzS");


var $iDrrr = parcelRequire("iDrrr");


var $6n7Az = parcelRequire("6n7Az");


var $bZ0lw = parcelRequire("bZ0lw");

const $3770d3a84e57d8c5$export$5412bb65cf4db44f = (dimensions)=>!dimensions.width && !dimensions.height;


async function $6815a15fcf608a7e$export$4fb742eff9613f2d(mediaType, file) {
    switch(mediaType){
        case 'image':
        case 'video':
            {
                const dimensions = await (0, $bZ0lw.getDimensionsFromBlob)(mediaType, file);
                if ((0, $3770d3a84e57d8c5$export$5412bb65cf4db44f)(dimensions)) return {
                    file: file,
                    scaleFactor: 1
                };
                return {
                    file: file,
                    dimensions: dimensions,
                    scaleFactor: 1
                };
            }
        default:
            return {
                file: file
            };
    }
}



var $l7jW8 = parcelRequire("l7jW8");

async function $c3907ebfddfc9502$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await (0, $l7jW8.fileToDataURI)(file)
    };
}


function $292e3d64f1a70570$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}


function $9735eb77d6c54560$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}



var $4n1J4 = parcelRequire("4n1J4");

// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $66873ce84668fb95$var$DPI_WEB_BASELINE = 72;
function $66873ce84668fb95$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = (0, $9735eb77d6c54560$export$11cb6a214555dd36)(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
     * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
     * So we are only relying on X axis.
     */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $66873ce84668fb95$var$DPI_WEB_BASELINE;
        else return (0, $292e3d64f1a70570$export$268f92356524130b)(tags, (0, $4n1J4.SupportedImageMetaTag).XResolution, $66873ce84668fb95$var$DPI_WEB_BASELINE) / $66873ce84668fb95$var$DPI_WEB_BASELINE;
    } else return 1;
}


function $7a3fa5b947c76ba2$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}


function $159905dfbf1c6c37$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}




var $je5JP = parcelRequire("je5JP");

async function $61de22f753848294$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $je5JP.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = (0, $292e3d64f1a70570$export$268f92356524130b)(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = (0, $292e3d64f1a70570$export$268f92356524130b)(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
   * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
   * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
   * We've also received JAC tickets reporting incorrect dimensions because of this
   * https://jira.atlassian.com/browse/CONFCLOUD-78275
   * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
   */ try {
        const img = await (0, $7a3fa5b947c76ba2$export$fe58198efe02b173)(src);
        const { width: width, height: height } = (0, $159905dfbf1c6c37$export$325d46491952db2d)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}


async function $1f447bb0844a452e$export$2176b0e68c10508f(fileInfo) {
    const metadata = await (0, $61de22f753848294$export$c142eb1c8c5c79c)(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = (0, $66873ce84668fb95$export$dd08dbbf61041ccd)(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}


async function $a69bf13f83aa7ad9$export$34f0dda2cf8fd624(file, devicePixelRatio) {
    const fileInfo = await (0, $c3907ebfddfc9502$export$ca39f27fe4f7d9b4)(file);
    const imageInfo = await (0, $1f447bb0844a452e$export$2176b0e68c10508f)(fileInfo);
    if (imageInfo === null) return {
        file: file
    };
    else {
        const { width: width, height: height, scaleFactor: scaleFactor } = imageInfo;
        const preview = {
            file: file,
            dimensions: {
                width: width,
                height: height
            },
            scaleFactor: devicePixelRatio || scaleFactor
        };
        return preview;
    }
}
const $a69bf13f83aa7ad9$export$5993f94be79b482e = 1;


const $db74ace8fd9dae76$var$generateTraceContext = ()=>({
        traceId: (0, $8396x.getRandomTelemetryId)()
    });
// Extracts the `DOMException` from a FileReader `ProgressEvent` (`target.error`).
// Bare `DOMException`s are `Error`s, so `onFileError` handles them before this.
const $db74ace8fd9dae76$var$extractDomException = (error)=>{
    const target = error?.target;
    return target?.error instanceof DOMException ? target.error : undefined;
};
// Defence-in-depth: turns a raw FileReader `ProgressEvent` into a real `Error`
// so analytics records the `DOMException` name instead of `{"isTrusted":true}`.
const $db74ace8fd9dae76$var$normalizeUploadError = (error)=>{
    const domException = $db74ace8fd9dae76$var$extractDomException(error);
    return domException ? (0, $eZgLI.toFileReaderError)(domException) : undefined;
};
class $db74ace8fd9dae76$export$be35ed9686ead209 {
    setUploadParams(uploadParams) {
        this.tenantUploadParams = uploadParams;
    }
    // Used for testing
    createUploadController() {
        return new (0, $f4X7g.UploadController)();
    }
    addFiles(files) {
        this.addFilesWithSource(files.map((file)=>({
                file: file,
                source: (0, $6n7Az.LocalFileSource).LocalUpload
            })));
    }
    addFile(file, replaceFileId) {
        this.addFilesWithSource([
            {
                file: file,
                source: (0, $6n7Az.LocalFileSource).LocalUpload,
                replaceFileId: replaceFileId
            }
        ]);
    }
    async addFilesWithSource(files, traceContext = $db74ace8fd9dae76$var$generateTraceContext()) {
        const shouldBatchSequentially = this.uploadBatchSize && this.uploadBatchSize > 0 && (0, $iDrrr.fg)('platform_media_picker_upload_batching');
        if (shouldBatchSequentially) {
            const batchSize = this.uploadBatchSize;
            for(let i = 0; i < files.length; i += batchSize){
                if (i > 0 && this.uploadBatchDelayMs > 0) await new Promise((resolve)=>setTimeout(resolve, this.uploadBatchDelayMs));
                await this.addFilesAndUpload(files.slice(i, i + batchSize), traceContext, true);
            }
        } else {
            const batches = [];
            for(let iterator = 0; iterator < files.length; iterator += this.maxUploadBatchSize)batches.push(this.addFilesAndUpload(files.slice(iterator, iterator + this.maxUploadBatchSize), traceContext));
            await Promise.all(batches);
        }
    }
    isCancellableFileUpload(fileUpload) {
        return fileUpload !== null;
    }
    cancel(id) {
        if (id) {
            const cancellableFileUpload = this.cancellableFilesUploads[id];
            if (cancellableFileUpload && cancellableFileUpload.cancel) cancellableFileUpload.cancel();
        } else Object.keys(this.cancellableFilesUploads).forEach((key)=>{
            const cancellableFileUpload = this.cancellableFilesUploads[key];
            if (cancellableFileUpload.cancel) cancellableFileUpload.cancel();
        });
    }
    on(event, listener) {
        this.emitter.on(event, listener);
    }
    off(event, listener) {
        this.emitter.off(event, listener);
    }
    async addFilesAndUpload(files, traceContext, awaitUploadCompletion = false) {
        if (files.length === 0) return;
        const creationDate = Date.now();
        const { userMediaClient: userMediaClient, tenantMediaClient: tenantMediaClient, shouldCopyFileToRecents: shouldCopyFileToRecents } = this;
        const mediaClient = shouldCopyFileToRecents ? tenantMediaClient : userMediaClient;
        const { collection: collectionTentant, expireAfter: expireAfter } = this.tenantUploadParams;
        const collection = shouldCopyFileToRecents ? collectionTentant : (0, $fkYei.RECENTS_COLLECTION);
        if (!mediaClient) return;
        const touchFileDescriptors = [];
        for(let i = 0; i < files.length; i++){
            const { replaceFileId: replaceFileId, file: file } = files[i];
            touchFileDescriptors.push({
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                fileId: replaceFileId || (0, $03RpJ.default)(),
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                occurrenceKey: (0, $03RpJ.default)(),
                collection: collection,
                size: file.size,
                expireAfter: expireAfter
            });
        }
        let touchedFiles;
        let caughtError;
        try {
            touchedFiles = await mediaClient.file.touchFiles(touchFileDescriptors, collection, traceContext);
        } catch (error) {
            caughtError = error;
        }
        const uploadCompletions = [];
        const cancellableFileUploads = files.map(({ file: file, source: source }, i)=>{
            const { fileId: id, occurrenceKey: occurrenceKey } = touchFileDescriptors[i];
            // exclude rejected files from being uploaded
            const rejectedFile = touchedFiles?.rejected?.find(({ fileId: rejectedFileId })=>rejectedFileId === id);
            if (rejectedFile) {
                if (this.fileRejectionHandler) this.fileRejectionHandler({
                    reason: 'fileSizeLimitExceeded',
                    fileName: file.name,
                    limit: rejectedFile.error.limit
                });
                return null;
            }
            // exclude empty files from being uploaded
            if (file.size === 0) {
                if (this.fileEmptyHandler) this.fileEmptyHandler({
                    reason: 'fileEmpty',
                    fileName: file.name
                });
                return null;
            }
            const touchedFile = touchedFiles?.created.find((touchedFile)=>touchedFile.fileId === id);
            let deferredUploadId;
            const isIdConflictError = caughtError instanceof (0, $dBBnL.RequestError) && caughtError.metadata?.statusCode === 409;
            if (touchedFile) deferredUploadId = Promise.resolve(touchedFile.uploadId);
            else if (isIdConflictError) // will occur when the backend receives a fileId that already exists in which case
            // we will create a single upload session for that file and use that uploadId
            deferredUploadId = mediaClient.mediaStore.createUpload(1, collection, traceContext).then((res)=>{
                return res.data[0].id;
            });
            else // in the case of unexpected errors, we want to defer the throwing of the error
            // until after the files-added has been emitted,
            // allows editor to show a broken media card for unexpected errors
            deferredUploadId = Promise.reject(caughtError);
            const uploadableFile = {
                collection: collection,
                content: file,
                name: file.name,
                mimeType: file.type,
                size: file.size
            };
            const uploadableUpfrontIds = {
                id: id,
                occurrenceKey: occurrenceKey,
                deferredUploadId: deferredUploadId
            };
            const controller = this.createUploadController();
            const sourceFileObservable = mediaClient.file.upload(uploadableFile, controller, uploadableUpfrontIds, traceContext);
            const mediaFile = {
                id: id,
                name: file.name,
                size: file.size,
                creationDate: creationDate,
                type: file.type,
                occurrenceKey: occurrenceKey
            };
            const cancellableFileUpload = {
                mediaFile: mediaFile,
                file: file,
                source: source,
                cancel: ()=>{
                    // we can't do "cancellableFileUpload.cancel = controller.abort" because will change the "this" mediaClient
                    controller.abort();
                }
            };
            let resolveUploadCompletion;
            if (awaitUploadCompletion) uploadCompletions.push(new Promise((resolve)=>{
                resolveUploadCompletion = resolve;
            }));
            const { unsubscribe: unsubscribe } = sourceFileObservable.subscribe({
                next: (state)=>{
                    if (state.status === 'processing' || state.status === 'processed' || state.status === 'failed-processing') {
                        unsubscribe();
                        if (shouldCopyFileToRecents) {
                            mediaClient.emit('file-added', state);
                            (0, $hfrng.globalMediaEventEmitter).emit('file-added', state);
                        }
                        this.onFileSuccess(cancellableFileUpload, id, traceContext);
                        resolveUploadCompletion?.();
                    }
                    if (state.status === 'error') {
                        this.onFileError(mediaFile, 'upload_fail', state.message || 'no-message', traceContext);
                        resolveUploadCompletion?.();
                    }
                },
                error: (error)=>{
                    this.onFileError(mediaFile, 'upload_fail', error, traceContext);
                    resolveUploadCompletion?.();
                }
            });
            this.cancellableFilesUploads[id] = cancellableFileUpload;
            return cancellableFileUpload;
        });
        const filteredCancellableFileUploads = cancellableFileUploads.filter(this.isCancellableFileUpload);
        const mediaFiles = filteredCancellableFileUploads.map((cancellableFileUpload)=>cancellableFileUpload.mediaFile);
        this.emit('files-added', {
            files: mediaFiles,
            traceContext: traceContext
        });
        this.emitPreviews(filteredCancellableFileUploads);
        if (awaitUploadCompletion && uploadCompletions.length > 0) await Promise.allSettled(uploadCompletions);
    }
    emitPreviews(cancellableFileUploads) {
        cancellableFileUploads.forEach((cancellableFileUpload)=>{
            const { file: file, mediaFile: mediaFile, source: source } = cancellableFileUpload;
            const { type: type } = file;
            const mediaType = this.getMediaTypeFromFile(file);
            if (!(0, $9OT81.isMimeTypeSupportedByBrowser)(type)) {
                this.emit('file-preview-update', {
                    file: mediaFile,
                    preview: {}
                });
                return;
            }
            if (mediaType === 'image') (0, $a69bf13f83aa7ad9$export$34f0dda2cf8fd624)(file, source === (0, $6n7Az.LocalFileSource).PastedScreenshot ? window.devicePixelRatio : undefined).then((preview)=>{
                this.emit('file-preview-update', {
                    file: mediaFile,
                    preview: preview
                });
            });
            else (0, $6815a15fcf608a7e$export$4fb742eff9613f2d)(mediaType, file).then((preview)=>{
                this.emit('file-preview-update', {
                    file: mediaFile,
                    preview: preview
                });
            }).catch(()=>this.emit('file-preview-update', {
                    file: mediaFile,
                    preview: {}
                }));
        });
    }
    getMediaTypeFromFile(file) {
        const { type: type } = file;
        return (0, $nfEzS.getMediaTypeFromMimeType)(type);
    }
    releaseCancellableFile(mediaFile) {
        delete this.cancellableFilesUploads[mediaFile.id];
    }
    onFileEmpty(handler) {
        this.fileEmptyHandler = handler;
    }
    onFileRejection(handler) {
        this.fileRejectionHandler = handler;
    }
    constructor(tenantMediaClient, tenantUploadParams, shouldCopyFileToRecents, maxUploadBatchSize = 255, // Max supported batch is 255. We parametrise it for testing purposes
    uploadBatchSize = 20, uploadBatchDelayMs = 1000){
        this.tenantMediaClient = tenantMediaClient;
        this.tenantUploadParams = tenantUploadParams;
        this.shouldCopyFileToRecents = shouldCopyFileToRecents;
        this.maxUploadBatchSize = maxUploadBatchSize;
        this.uploadBatchSize = uploadBatchSize;
        this.uploadBatchDelayMs = uploadBatchDelayMs;
        this.userMediaClient = void 0;
        this.emitter = void 0;
        this.cancellableFilesUploads = void 0;
        this.fileRejectionHandler = void 0;
        this.fileEmptyHandler = void 0;
        this.emit = (event, payload)=>{
            this.emitter.emit(event, payload);
        };
        this.onFileSuccess = async (cancellableFileUpload, fileId, traceContext)=>{
            const { mediaFile: mediaFile } = cancellableFileUpload;
            this.emit('file-converting', {
                file: mediaFile,
                traceContext: traceContext
            });
            cancellableFileUpload.cancel = ()=>{
                this.releaseCancellableFile(mediaFile);
            };
        };
        this.onFileError = (mediaFile, name, error, traceContext)=>{
            this.releaseCancellableFile(mediaFile);
            if (error === 'canceled') // Specific error coming from chunkinator via rejected fileId promise.
            // We do not want to trigger error in this case.
            return;
            let description;
            let rawError;
            if (error instanceof Error) {
                description = error.message;
                rawError = error;
            } else if ((0, $iDrrr.fg)('platform_media_filereader_error_surfacing')) {
                rawError = $db74ace8fd9dae76$var$normalizeUploadError(error);
                description = rawError?.message ?? (typeof error === 'string' ? error : 'unknown');
            } else {
                description = error;
                rawError = undefined;
            }
            this.emit('file-upload-error', {
                fileId: mediaFile.id,
                error: {
                    fileId: mediaFile.id,
                    name: name,
                    description: description,
                    rawError: rawError
                },
                traceContext: traceContext
            });
        };
        this.emitter = new (0, $7XeMy.EventEmitter2)();
        this.cancellableFilesUploads = {};
    }
}



var $gVALF = parcelRequire("gVALF");

var $cFc8s = parcelRequire("cFc8s");


var $c2smn = parcelRequire("c2smn");


var $fh15z = parcelRequire("fh15z");


var $4MiWC = parcelRequire("4MiWC");

let $039cb6383d7dc271$var$ufoExperience;
function $039cb6383d7dc271$export$bf512347bf3a9e16(id, componentName) {
    if (!$039cb6383d7dc271$var$ufoExperience) {
        if (!componentName) return undefined;
        const inlineExperience = {
            platform: {
                component: `media-picker-${componentName}`
            },
            type: (0, $4MiWC.ExperienceTypes).Experience,
            performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
            featureFlags: (0, $c2smn.getFeatureFlagKeysAllProducts)()
        };
        $039cb6383d7dc271$var$ufoExperience = new (0, $fh15z.ConcurrentExperience)('media-upload', inlineExperience);
    }
    return $039cb6383d7dc271$var$ufoExperience.getInstance(id);
}


const $892d60a8d36732f6$var$packageName = "platform-pkg";
const $892d60a8d36732f6$var$packageVersion = "0.0.0-use.local";
const $892d60a8d36732f6$export$aa991898181926b9 = (id, properties)=>{
    const refinedMetadata = {
        ...properties,
        packageName: $892d60a8d36732f6$var$packageName,
        packageVersion: $892d60a8d36732f6$var$packageVersion,
        mediaEnvironment: (0, $gVALF.getMediaEnvironment)(),
        mediaRegion: (0, $cFc8s.getMediaRegion)()
    };
    (0, $039cb6383d7dc271$export$bf512347bf3a9e16)(id)?.failure({
        metadata: refinedMetadata
    });
};



var $dOxiJ = parcelRequire("dOxiJ");

function $60768e8775b04653$export$989e1becee2b9994(error) {
    if (error && (0, $dOxiJ.isRequestError)(error)) return error.metadata;
}



const $831c6793513d604d$export$aca2a1278c2ebf9a = (id, componentName)=>{
    (0, $039cb6383d7dc271$export$bf512347bf3a9e16)(id, componentName)?.start();
};








const $77f4178e566119ca$var$packageName = "platform-pkg";
const $77f4178e566119ca$var$packageVersion = "0.0.0-use.local";
const $77f4178e566119ca$export$3730e235c28b02d0 = (id, properties)=>{
    (0, $039cb6383d7dc271$export$bf512347bf3a9e16)(id)?.success({
        metadata: {
            fileAttributes: properties,
            packageName: $77f4178e566119ca$var$packageName,
            packageVersion: $77f4178e566119ca$var$packageVersion,
            mediaEnvironment: (0, $gVALF.getMediaEnvironment)(),
            mediaRegion: (0, $cFc8s.getMediaRegion)()
        }
    });
};





class $d4431e21f1f75de6$export$b538d95162a51b88 {
    once(event, listener) {
        this.emitter.once(event, listener);
    }
    on(event, listener) {
        this.emitter.on(event, listener);
    }
    onAny(listener) {
        this.emitter.onAny(listener);
    }
    addListener(event, listener) {
        this.emitter.addListener(event, listener);
    }
    off(event, listener) {
        this.emitter.off(event, listener);
    }
    removeListener(event, handler) {
        this.emitter.removeListener(event, handler);
    }
    removeAllListeners(event) {
        // We want to explicitly call removeAllListeners without any argument if event is undefined, otherwise will EventEmitter fail
        if (event === undefined) this.emitter.removeAllListeners();
        else this.emitter.removeAllListeners(event);
    }
    emit(event, payload) {
        return this.emitter.emit(event, payload);
    }
    constructor(){
        this.emitter = new (0, $7XeMy.EventEmitter2)({
            wildcard: true
        });
    }
}


class $da465c477a2eff96$export$4ab2ad4b4d3e37a1 extends (0, $d4431e21f1f75de6$export$b538d95162a51b88) {
    emitPluginItemsInserted(selectedPluginItems) {
        const payload = selectedPluginItems.map((item)=>{
            return {
                pluginName: item.serviceName,
                pluginFile: {
                    id: item.id,
                    metadata: item.metadata
                }
            };
        });
        this.emit('plugin-items-inserted', payload);
    }
    emitUploadsStart(files, traceContext) {
        this.emit('uploads-start', {
            files: files,
            traceContext: traceContext
        });
    }
    emitUploadPreviewUpdate(file, preview) {
        this.emit('upload-preview-update', {
            file: file,
            preview: preview
        });
    }
    emitUploadEnd(file, traceContext) {
        this.emit('upload-end', {
            file: file,
            traceContext: traceContext
        });
    }
    emitUploadError(fileId, error, traceContext) {
        this.emit('upload-error', {
            fileId: fileId,
            error: error,
            traceContext: traceContext
        });
    }
}


class $c822d5cca28f9175$export$b7469e2ea01fbbd1 extends (0, $cozmU.Component) {
    setUploadParams(uploadParams) {
        this.uploadService.setUploadParams(uploadParams);
    }
    constructor(props, componentName){
        super(props), this.componentName = componentName;
        this.uploadService = void 0;
        this.uploadComponent = new (0, $da465c477a2eff96$export$4ab2ad4b4d3e37a1)();
        this.state = {
            errorFlags: []
        };
        this.addErrorFlag = (flagData)=>{
            this.setState({
                errorFlags: [
                    ...this.state.errorFlags,
                    flagData
                ]
            });
        };
        this.dismissErrorFlag = ()=>{
            this.setState({
                errorFlags: this.state.errorFlags.slice(1)
            });
        };
        this.fireCommencedEvent = (payload)=>{
            const { files: files, traceContext: traceContext } = payload;
            files.forEach(({ id: fileId, size: fileSize, type: fileMimetype })=>{
                (0, $1AU2X.start)(`MediaPicker.fireUpload.${fileId}`);
                this.createAndFireAnalyticsEvent({
                    eventType: 'operational',
                    action: 'commenced',
                    actionSubject: 'mediaUpload',
                    actionSubjectId: 'localMedia',
                    attributes: {
                        sourceType: 'local',
                        serviceName: 'upload',
                        fileAttributes: {
                            fileId: fileId,
                            fileSize: fileSize,
                            fileMimetype: fileMimetype
                        },
                        traceContext: traceContext
                    }
                });
                (0, $831c6793513d604d$export$aca2a1278c2ebf9a)(fileId, this.componentName);
            });
        };
        this.fireUploadSucceeded = (payload)=>{
            const { file: { id: fileId, size: fileSize, type: fileMimetype }, traceContext: traceContext } = payload;
            const { duration: uploadDurationMsec = -1 } = (0, $1AU2X.end)(`MediaPicker.fireUpload.${fileId}`);
            this.createAndFireAnalyticsEvent({
                eventType: 'operational',
                action: 'succeeded',
                actionSubject: 'mediaUpload',
                actionSubjectId: 'localMedia',
                attributes: {
                    sourceType: 'local',
                    serviceName: 'upload',
                    status: 'success',
                    fileAttributes: {
                        fileId: fileId,
                        fileSize: fileSize,
                        fileMimetype: fileMimetype
                    },
                    uploadDurationMsec: uploadDurationMsec,
                    traceContext: traceContext
                }
            });
            (0, $77f4178e566119ca$export$3730e235c28b02d0)(fileId, {
                fileId: fileId,
                fileSize: fileSize,
                fileMimetype: fileMimetype
            });
        };
        this.fireUploadFailed = async (payload)=>{
            const { fileId: fileId, error: { name: errorName, rawError: rawError }, traceContext: traceContext } = payload;
            const { duration: uploadDurationMsec = -1 } = (0, $1AU2X.end)(`MediaPicker.fireUpload.${fileId}`);
            const errorDetail = rawError && (0, $1wzQC.isCommonMediaClientError)(rawError) && rawError.innerError?.message ? rawError.innerError?.message : rawError instanceof Error ? rawError.message : payload.error.description;
            const requestMetadata = !!rawError ? (0, $60768e8775b04653$export$989e1becee2b9994)(rawError) : undefined;
            this.createAndFireAnalyticsEvent({
                eventType: 'operational',
                action: 'failed',
                actionSubject: 'mediaUpload',
                actionSubjectId: 'localMedia',
                attributes: {
                    sourceType: 'local',
                    serviceName: 'upload',
                    status: 'fail',
                    failReason: errorName,
                    error: !!rawError ? (0, $e5ee1fb593dbb4c1$export$c15d72765ee2baa4)(rawError) : 'unknown',
                    statusCode: requestMetadata?.statusCode,
                    request: requestMetadata,
                    fileAttributes: {
                        fileId: fileId
                    },
                    uploadDurationMsec: uploadDurationMsec,
                    traceContext: traceContext,
                    errorDetail: errorDetail
                }
            });
            (0, $892d60a8d36732f6$export$aa991898181926b9)(fileId, {
                failReason: errorName,
                error: !!rawError ? (0, $e5ee1fb593dbb4c1$export$c15d72765ee2baa4)(rawError) : 'unknown',
                errorDetail: errorDetail,
                statusCode: requestMetadata?.statusCode,
                request: requestMetadata,
                fileAttributes: {
                    fileId: fileId
                },
                uploadDurationMsec: uploadDurationMsec
            });
        };
        this.createAndFireAnalyticsEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $8lZ3h.ANALYTICS_MEDIA_CHANNEL));
        };
        this.cancel = (uniqueIdentifier)=>{
            this.uploadService.cancel(uniqueIdentifier);
        };
        this.onFilesAdded = ({ files: files, traceContext: traceContext })=>{
            this.uploadComponent.emitUploadsStart(files, traceContext);
        };
        this.onFilePreviewUpdate = ({ file: file, preview: preview })=>{
            this.uploadComponent.emitUploadPreviewUpdate(file, preview);
        };
        this.onFileConverting = ({ file: file, traceContext: traceContext })=>{
            this.uploadComponent.emitUploadEnd(file, traceContext);
        };
        this.onUploadError = ({ fileId: fileId, error: error, traceContext: traceContext })=>{
            this.uploadComponent.emitUploadError(fileId, error, traceContext);
        };
        const { mediaClient: mediaClient, config: config, onUploadsStart: onUploadsStart, onPreviewUpdate: onPreviewUpdate, onEnd: onEnd, onError: onError } = this.props;
        const tenantUploadParams = config.uploadParams;
        const { shouldCopyFileToRecents: shouldCopyFileToRecents = true } = config;
        this.uploadComponent.on('uploads-start', this.fireCommencedEvent);
        this.uploadComponent.on('upload-end', this.fireUploadSucceeded);
        this.uploadComponent.on('upload-error', this.fireUploadFailed);
        if (onUploadsStart) this.uploadComponent.on('uploads-start', onUploadsStart);
        if (onPreviewUpdate) this.uploadComponent.on('upload-preview-update', onPreviewUpdate);
        if (onEnd) this.uploadComponent.on('upload-end', onEnd);
        if (onError) this.uploadComponent.on('upload-error', onError);
        this.uploadService = new (0, $db74ace8fd9dae76$export$be35ed9686ead209)(mediaClient, tenantUploadParams, shouldCopyFileToRecents, undefined, config.uploadBatchSize, config.uploadBatchDelayMs);
        this.uploadService.on('files-added', this.onFilesAdded);
        this.uploadService.on('file-preview-update', this.onFilePreviewUpdate);
        this.uploadService.on('file-converting', this.onFileConverting);
        this.uploadService.on('file-upload-error', this.onUploadError);
        const onFileRejection = (rejectionData)=>{
            const { onUploadRejection: onUploadRejection } = tenantUploadParams;
            const shouldOverride = onUploadRejection?.(rejectionData);
            if (!shouldOverride) this.addErrorFlag(rejectionData);
        };
        this.uploadService.onFileRejection(onFileRejection);
        this.uploadService.onFileEmpty(onFileRejection);
    }
}
module.exports["LocalUploadComponentReact"] = $c822d5cca28f9175$export$b7469e2ea01fbbd1;

});

parcelRegister("6n7Az", function(module, exports) {
const $464e3b98cbdb69f1$export$b52f32369fbb9776 = 10e6; // 10 MB
var $464e3b98cbdb69f1$export$9f61a7e25675739f = /*#__PURE__*/ function(LocalFileSource) {
    LocalFileSource["PastedFile"] = "pastedFile";
    LocalFileSource["PastedScreenshot"] = "pastedScreenshot";
    LocalFileSource["LocalUpload"] = "localUpload";
    return LocalFileSource;
}({});
module.exports["LocalFileSource"] = $464e3b98cbdb69f1$export$9f61a7e25675739f;

});


//# sourceMappingURL=cardWithMediaClient.818bbc11.js.map
